/*
 * See more: http://docs.173ops.com/product/mi/auth/rule/
 * TODO 不支持魔图的也可以通过appid转换
 */
var IMAGE_FORMATS = {
      '240x': 'a-3-240x.jpg'
    , '320x': 'a-3-320x.jpg'
    , '480x': 'a-3-480x.jpg'
    }

module.exports = function(source, format) {
  var matched = source.match(/i\d*\.17173cdn\.com/g)
  if (!matched || matched.length < 1) {
    return source
  }
  if (!format) { format = '240x' }
  return source + '!' + IMAGE_FORMATS[format]
}
